import React from 'react';

import { makeStyles, Container, Typography, Grid } from '@material-ui/core';

import ImageHipaa from '../../assets/images/hipaa-blue.png';
import ImageMediphanyLogo from '../../assets/images/mediphany-logo.png';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      padding: '0px 30px',
    },
    copyrightContainer: {
      paddingBottom: '4px',
      paddingTop: '5px',
    },
    copyrightText: {
      color: '#FFFFFF',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      marginBottom: '0px !important',
      opacity: '0.3',
      textAlign: 'center',
    },
    imageHipaa: {
      height: 'auto',
      maxWidth: '81px',
    },
    imageMediphany: {
      height: 'auto',
      maxWidth: '58px',
    },
    link: {
      color: theme.palette.primary.main,
      display: 'block',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      padding: '5px 0px',
      textDecoration: 'none',
    },
    linkContainer: {
      paddingTop: '38px',
    },
    linkDevider: {
      color: '#FFFFFF',
      display: 'none',
    },
    parent: {
      background: '#172B4D',
    },
    [theme.breakpoints.up('md')]: {
      copyrightContainer: {
        paddingBottom: '20px',
        paddingTop: '10px',
      },
      imageHipaa: {
        height: 'auto',
        width: '85px',
      },
      imageMediphany: {
        height: 'auto',
        width: '58px',
      },
      link: {
        display: 'inline-block',
        padding: '0px',
      },
      linkContainer: {
        paddingTop: '50px',
      },
      linkDevider: {
        display: 'inline-block',
        margin: '0px 8px',
      },
    },
  };
});

export default () => {
  const classes = useStyles();
  return (
    <div className={classes.parent}>
      <Container className={classes.container}>
        {/* The links */}
        <div className={classes.linkContainer}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <img className={classes.imageMediphany} src={ImageMediphanyLogo} alt="Mediphany" />
            </Grid>
            <Grid item>
              <a className={classes.link} href="https://mediphany.com/terms-and-conditions/" target="_blank" rel="noreferrer">
                Terms and conditions
              </a>
              <span className={classes.linkDevider}>|</span>
              <a className={classes.link} href="https://mediphany.com/privacy-policy/" target="_blank" rel="noreferrer">
                Privacy policy
              </a>
            </Grid>
            <Grid item>
              <img className={classes.imageHipaa} src={ImageHipaa} alt="HIPAA" />
            </Grid>
          </Grid>
        </div>

        {/* Copyright */}
        <div className={classes.copyrightContainer}>
          <Typography className={classes.copyrightText}> Copyright 2024 &#169; All rights reserved. </Typography>
        </div>
      </Container>
    </div>
  );
};
